import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/styles";
import { useTheme } from "@material-ui/core";
import clsx from "clsx";
import { getVehicleImage } from "../../utils/images";
import { isMobile } from "../../utils/helpers";
import VehicleIcon from "../Icons/theme/Vehicle";
import { getVehicleColor } from "../Icons/theme/Vehicle/utils";
const useStyles = makeStyles(({
  breakpoints,
  typography
}) => ({
  wrapper: {
    position: "relative",
    margin: `${typography.pxToRem(15)} ${typography.pxToRem(10)} ${typography.pxToRem(20)} ${typography.pxToRem(15)}`
  },
  trackImg: {
    [breakpoints.down("xs")]: {
      height: typography.pxToRem(36)
    },
    position: "absolute",
    zIndex: 2,
    transform: "translate(-50%, -37%)",
    height: typography.pxToRem(38)
  },
  root: {
    height: typography.pxToRem(9),
    borderRadius: typography.pxToRem(5)
  },
  bar1: {
    background: "#808285"
  },
  bar2: {
    background: "#d8dde6"
  },
  bar3: {
    background: "#76b55a",
    animation: "none"
  },
  timeContainer: ({
    deliveryTimeWidth
  }) => ({
    position: "relative",
    marginLeft: "auto",
    width: deliveryTimeWidth,
    minWidth: typography.pxToRem(50)
  }),
  time: {
    position: "absolute",
    bottom: 0,
    zIndex: 3,
    color: "#1d9ad0",
    fontSize: typography.pxToRem(13),
    letterSpacing: 0.5,
    paddingBottom: typography.pxToRem(16),
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(10),
      paddingBottom: typography.pxToRem(10)
    }
  },
  timeStart: {
    left: typography.pxToRem(-20)
  },
  timeEnd: {
    right: typography.pxToRem(-10)
  }
}));

const TimeProgress = ({
  currentPosition,
  startPosition,
  windowStartTime,
  windowEndTime,
  vehicleTypeCode,
  isVehicleElectric
}) => {
  const styles = useStyles({
    deliveryTimeWidth: `${100 - startPosition}%`
  });
  const {
    name
  } = useTheme();
  const style = {
    left: `${currentPosition}%`
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(VehicleIcon, {
    name: "vehicle",
    style: isMobile ? { ...style,
      height: 36
    } : style,
    className: styles.trackImg,
    vehicleTypeCode: vehicleTypeCode,
    src: getVehicleImage(vehicleTypeCode),
    color: getVehicleColor(isVehicleElectric, name)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.timeContainer
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx(styles.time, styles.timeStart)
  }, windowStartTime), /*#__PURE__*/React.createElement("span", {
    className: clsx(styles.time, styles.timeEnd)
  }, windowEndTime)), /*#__PURE__*/React.createElement(LinearProgress, {
    variant: "buffer",
    classes: {
      root: styles.root,
      bar1Buffer: styles.bar1,
      bar2Buffer: styles.bar2,
      dashed: styles.bar3
    },
    value: currentPosition,
    valueBuffer: startPosition
  }));
};

export default TimeProgress;